module.exports = __webpack_public_path__ + "static/media/cyrus-the-great.93dd945e.jpg";